var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.verifyScope())?_vm._t("default"):_vm._e(),(!_vm.verifyScope())?_vm._t("not"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }